import React, { useState } from 'react';
import {useDispatch} from 'react-redux';
import {search} from '../actions';
import LocalizationMisc from '../miscs/LocalizationMisc';

type Props = {
  searchValue: string
};

const SearchInput = ( props: Props ) => {
  const dispatcher = useDispatch();
  const [value, setValue] = useState('');
  const iconClass = props.searchValue.length && value === props.searchValue ? 'cross' : 'search';
  return (<div className='SearchInput'>
    <input
      type='text'
      value={value}
      placeholder={LocalizationMisc.local('search.placeholder')}
      onChange={ (e: React.FormEvent<HTMLInputElement>) => {
        setValue( e.currentTarget.value );
      }}
      onKeyPress={ (e: React.KeyboardEvent<HTMLInputElement>) => {
        if ( e.key === 'Enter' && iconClass !== 'cross' ) {
          dispatcher( search( value ) );
        }
      } }
    />
    <i className={`icon icon-${iconClass}`} onClick={ () => {
      dispatcher( search( iconClass === 'cross' ? '' : value ) );
      if ( iconClass === 'cross' ) {
        setValue('');
      }
    } }/>
  </div>);
}

export default SearchInput;